<template>
  <div class="prcie_ep">
    <Menu />
    <div class="cont">
      <div class="dt_back"></div>
      <pricingTop type="dt" />
      <div class="tabs">
        <router-link class="titem titem1" to="/pricing_individual.html">个人版</router-link>
        <router-link class="titem titem1" to="/pricing_enterprise.html">企业版</router-link>
        <router-link class="titem titem0 dt_titem" to="/pricing_pc">
          <div class="p_new">NEW</div>
          云电脑
        </router-link>
      </div>

      <div class="mcompany">
        <div class="flexWrap">
          <!-- 主流游戏特惠 -->
          <div class="mbox techsupport_box mhover_box">
            <div class="mtop main_current">
              <div class="top"></div>
              <div class="promotional_label"></div>
              <div class="t_content">
                <div class="main_back"></div>
                <p class="mttitle">主流游戏特惠</p>
                <p class="mtsubtitle">游戏娱乐性价比首选</p>
                <div class="price1">
                  <span class="price_text1">¥</span><span class="price_text2">0</span><span
                    class="price_text3">.98</span><span class="price_text4">/小时</span>
                </div>
                <div class="m_content">
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/CPU.png" />
                    <span class="span1">CPU</span>
                    <span class="span_empty"></span>
                    <span class="span2">等同于11代酷睿i7</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/memory.png" />
                    <span class="span1">内存</span>
                    <span class="span_empty"></span>
                    <span class="span2">32GB</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/GPU.png" />
                    <span class="span1">显卡</span>
                    <span class="span_empty"></span>
                    <span class="span2 gpu">RTX3060</span>
                  </p>
                </div>
                <a class="mark_btn1 download1" target="_blank" id="daas_buy_3060_dl_btn"
                  :href="`https://pc.todesk.com/download`">立即下载</a>
              </div>
            </div>
          </div>
          <!-- 大型游戏利器 -->
          <div class="mbox techsupport_box mhover_box">
            <div class="mtop large-scale">
              <div class="top"></div>
              <div class="t_content">
                <div class="large_scale_back"></div>
                <p class="mttitle">大型游戏利器</p>
                <p class="mtsubtitle">高效畅玩3A游戏大作</p>
                <div class="price1">
                  <span class="price_text1">¥</span><span class="price_text2">1</span><span
                    class="price_text3">.20</span><span class="price_text4">/小时起</span>
                </div>
                <div class="m_content">
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/CPU.png" />
                    <span class="span1">CPU</span>
                    <span class="span_empty"></span>
                    <span class="span2">12代酷睿i7</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/memory.png" />
                    <span class="span1">内存</span>
                    <span class="span_empty"></span>
                    <span class="span2">32GB起</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/GPU.png" />
                    <span class="span1">显卡</span>
                    <span class="span_empty"></span>
                    <span class="span2 gpu">RTX4070</span>
                  </p>
                </div>
                <a class="mark_btn1 download2" target="_blank" id="daas_buy_4070_dl_btn"
                  :href="`https://pc.todesk.com/download`">立即下载</a>
              </div>
            </div>
          </div>
          <!-- AIGC进阶版 -->
          <div class="mbox techsupport_box mhover_box">
            <div class="mtop aigc1">
              <div class="top"></div>
              <div class="t_content">
                <div class="s_back aigc1_back"></div>
                <p class="mttitle">云图形工作站</p>
                <p class="mtsubtitle">轻松应对复杂图形设计</p>
                <div class="price1 coming_aigc1">
                  <span class="price_text1">¥</span><span class="price_text2">2</span><span
                    class="price_text3">.08</span><span class="price_text4">/小时起</span>
                </div>
                <div class="m_content">
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/CPU.png" />
                    <span class="span1">CPU</span>
                    <span class="span_empty"></span>
                    <span class="span2">等同于12代酷睿i5</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/memory.png" />
                    <span class="span1">内存</span>
                    <span class="span_empty"></span>
                    <span class="span2">32GB</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/GPU.png" />
                    <span class="span1">显卡</span>
                    <span class="span_empty"></span>
                    <span class="span2 gpu">RTX4070</span>
                  </p>
                </div>
                <a class="mark_btn1 download3" href="https://pc.todesk.com/download" id="daas_buy_4090_dl_btn">立即下载</a>
              </div>
            </div>
          </div>
          <!-- AIGC增强版 -->
          <div class="mbox techsupport_box mhover_box">
            <div class="mtop aigc2">
              <div class="top"></div>
              <div class="t_content">
                <div class="s_back aigc2_back"></div>
                <p class="mttitle">AIGC藏宝地</p>
                <p class="mtsubtitle">内置多模态AIGC大模型 </p>
                <div class="price1 coming_aigc2">
                  <span class="price_text1">¥</span><span class="price_text2">2</span><span
                    class="price_text3">.77</span><span class="price_text4">/小时</span>
                </div>
                <div class="m_content">
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/CPU.png" />
                    <span class="span1">CPU</span>
                    <span class="span_empty"></span>
                    <span class="span2">等同于11代酷睿i7</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/memory.png" />
                    <span class="span1">内存</span>
                    <span class="span_empty"></span>
                    <span class="span2">64GB</span>
                  </p>
                  <p>
                    <img class="img1" src="@/assets/todesk/pricing/dt/GPU.png" />
                    <span class="span1">显卡</span>
                    <span class="span_empty"></span>
                    <span class="span2 gpu">GTX4090</span>
                  </p>
                </div>
                <a class="mark_btn1 download4" href="https://pc.todesk.com/download" id="daas_buy_4090_dl_btn">立即下载</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Scenes :path="path" />
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import pricingTop from "@/components/pricingTop";
import Scenes from "@/views/pricingNext/Scenes.vue";

export default {
  components: {
    Menu,
    Footer,
    pricingTop,
    Scenes,
  },
  data() {
    return {
      path: "/desktron/contact",
    };
  },
  methods: {
    getService() {
      window.location.href = "https://enterprise.todesk.com/contact";
    },
    handleClick() {
      this.$router.push({
        path: "/desktron/contact",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.prcie_ep {
  background: #fff;

  .cont {
    padding-bottom: 0px;
    // background: url("~@/assets/pricing/pricing_bg@3x.png") no-repeat;
    background: linear-gradient(0deg, #FFFFFF 84.72%, #ADDBFF 100%);
    background-size: 100% auto;
    background-repeat: no-repeat;
    .dt_back{
      background: url("~@/assets/todesk/pricing/dt/dt_back.png") no-repeat;
      background-size: 100% auto;
      background-repeat: no-repeat;
      position: absolute;
      width: 100%;
      height: 260px;
    }
    .tabs {
      position: relative;
      width: fit-content;
      height: 50px;
      background: #FFFFFF;
      border-radius: 25px;
      padding: 4px;
      box-sizing: border-box;
      margin: auto;
      margin-top: 18px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, .05);

      .titem {
        width: 106px;
        height: 42px;
        border-radius: 21px;
        display: inline-block;
        text-align: center;
        line-height: 42px;
      }

      .titem0 {
        background: #37B3FC;
        box-shadow: 0px 2px 4px 0px rgba(0, 68, 152, 0.18);
        color: #131314;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      .dt_titem{
        position: relative;
        .p_new{
          position: absolute;
          top: -8px;
          right: 4px;
          background: linear-gradient(88.88deg, #B055F7 -8.97%, #FF984E 93.3%);
          padding: 2px 4px;
          border-radius: 4px;
          font-size: 10px;
          line-height: 12px;
          color: #fff;
          font-weight: 700;
        }
      }

      .titem1 {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131314;
      }
    }
    .mcompany {
      position: relative;
      margin: 42px auto 0px auto;
      .mttitle {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #272727;
        line-height: 37px;
      }
      .mtsubtitle {
        margin-top: 8px;
        height: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898D;
      }
      .mtbtn {
        width: 210px;
        height: 50px;
        border-radius: 4px;
        border: 1px solid #1AA3F2;
        line-height: 48px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
        margin: auto;
        margin-top: 20px;
        display: block;
        background: #1AA3F2;
      }
      .mtbtn:hover {
        background: #1AA3F2;
        border-color: #1AA3F2;
        color: #fff;
      }
      .mtbtn:active {
        background: #0C97E8;
        border-color: #0C97E8;
      }
      .mtprice {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 13px;
      }
      .mtprice .get_server_pic {
        width: 100px;
        height: 100px;
        position: relative;
        top: 50px;
      }
      .mtprice_info {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #88898D;
        line-height: 20px;
        height: 40px;
      }
      .mtfeature {
        height: 200px;
        padding-top: 16px;
        box-sizing: border-box;
        padding-left: 38px;
      }
      .mtfeature_item {
        height: 40px;
        display: flex;
        align-items: center;
      }
      .mtfeature_item img {
        width: 18px;
        height: auto;
        margin-right: 8px;
      }
      .mtfeature_item span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #272727;
      }
      // .m_content {
      //   margin: 0px 39px;
      //   height: 170px;
      // }
      // .m_content p {
      //   margin-bottom: 20px;
      //   display: flex;
      //   color: #272727;
      //   font-size: 14px;
      // }
      // .m_content p span {
      //   flex: 1;
      // }
      // .m_content p .span1 {
      //   text-align: left;
      // }
      // .m_content p .span2 {
      //   text-align: right;
      // }
      .m_select {
        width: 70px;
        padding: 5px 5px 5px 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        color: #232729;
        background-color: #fff;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url(~@/assets/pricing2/dt/up.png);
        background-repeat: no-repeat;
        background-position: 50px center;
        background-size: 12px;
        background-size: 12px;
        padding-right: 20px;
      }
      .m_select::-ms-expand {
        display: none;
      }
      #application{
        scroll-margin-top: 70px;
      }
      .m_select:focus {
        outline: none;
      }

      .mbox {
        text-align: center;
        width: 337px;
        padding-bottom: 24px;
        margin: 0px auto;
        .mtop {
          min-height: 380px;
          box-sizing: border-box;
          margin: 0px 5px 0px 5px;
          background: #ffffff;
          border-radius: 8px;
          border: 0.5px solid #0000001A;
          box-shadow: 0px 3.4px 8px 0px #0000001A,0px 1px 2px 0px #FFFFFF80;
          .top {
            height: 8px;
            background: #11BBF2;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
        
          &.main_current .top {
            background: #11BBF2;
          }
        
          &.large-scale .top {
            background: linear-gradient(90deg, #E6B509 0%, #D5840B 100%);
          }
        
          &.aigc1 .top {
            background: linear-gradient(90deg, #E37A00 0%, #AA4801 100%);
            ;
          }
        
          &.aigc2 .top {
            background: linear-gradient(90deg, #E32900 0%, #6D02C2 100%);
          }
        
          .t_content {
            padding-top: 30px;
            border-top: none;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            position: relative;
            overflow: hidden;
          }
        
          &.main_current .t_content {
            background: #F5FCFE;
          }
        
          &.large-scale .t_content {
            background: #FFFCED;
          }
        
          &.aigc1 .t_content {
            background: #FFF9F1;
          }
        
          &.aigc2 .t_content {
            background: linear-gradient(158.45deg, #FFF8F6 7.73%, #FBF6FF 100.05%);
          }
        }
      
        .m_content {
          padding-top: 12px;
          margin: 18px 40px 0px 40px;
          height: 150px;
          position: relative;
          border-top: 1px dashed #6D3C271F;
        
          .img1 {
            height: 20px;
            width: 20px;
            margin-right: 2px;
          }
        
          p {
            margin-bottom: 20px;
            display: flex;
            color: #000000;
            font-size: 14px;
            align-items: center;
          }
        
          .span_empty {
            flex: 1;
          }
        
          .gpu {
            background-image: url(~@/assets/todesk/pricing/dt/gpu_r.png);
            background-size: 91px 17px;
            background-repeat: no-repeat;
            background-position: 8px 2px;
            width: 96px;
            height: 24px;
            text-align: right;
            font-weight: bold;
          }
        
          .gpu_aigc2 {
            background-image: url(~@/assets/todesk/pricing/dt/gpu_r1.png);
            background-size: 63px 17px;
            background-position: 34px 2px;
          }
        }
      
        .mark_btn1 {
          width: 210px;
          height: 50px;
          border-radius: 4px;
          background: #11BBF2;
          line-height: 48px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          cursor: pointer;
          margin: 0px auto 24px auto;
          display: block;
        }
      
        .main_current:hover .download1 {
          background: #00A4DD;
        
          &:hover {
            background: #33B6E4;
            box-shadow: none;
          }
        
          &:active {
            background: #2E8CAE;
          }
        }
      
        .download1 {
          background: #11BBF2;
          box-shadow: 0px 3.4px 8px 0px #0038FF1A, 0px 1px 2px 0px #FFFFFF80;
        }
      
        .large-scale:hover .download2 {
          background: linear-gradient(90deg, #AA6401 0%, #72470C 100%);
        
          &:hover {
            background: linear-gradient(90deg, #B2731B 0%, #825A24 100%);
            box-shadow: none;
          }
        
          &:active {
            background: linear-gradient(90deg, #885002 0%, #5C3A0A 100%);
          }
        }
      
        .download2 {
          box-shadow: 0px 3.4px 8px 0px #FF6B0033, 0px 1px 2px 0px #FFFFFF80;
          background: linear-gradient(90deg, #E6B509 0%, #D5840B 100%);
        }
        
        .aigc1:hover .download3{
          &:active {
            background: linear-gradient(90deg, #D16C06 0%, #8C3E06 100%);
            box-shadow: 0px 3.4px 8px 0px #FF6B0033,0px 1px 2px 0px #FFFFFF80;
          }
        }

        .download3 {
          box-shadow: 0px 1px 2px 0px rgba(255, 255, 255, 0.50), 0px 3.4px 8px 0px rgba(255, 107, 0, 0.20);
          background: linear-gradient(90deg, #E37A00 0%, #AA4801 100%);
        }
        .aigc2:hover .download4{
          &:active {
            background: linear-gradient(90deg, #D1522A 0%, #6A0EB3 100%);
            box-shadow: 0px 3.4px 8px 0px #FF6B0033,0px 1px 2px 0px #FFFFFF80;
          }
        }
        .download4 {
          background: linear-gradient(90deg, #E05C24 0%, #7717C2 100%), linear-gradient(90deg, #DB7700 0%, #994101 100%);
          box-shadow: 0px 1px 2px 0px rgba(255, 255, 255, 0.50), 0px 3.4px 8px 0px rgba(255, 107, 0, 0.20);
        }
      
        .main_back {
          background-image: url(~@/assets/todesk/pricing/dt/main_back.png);
          background-size: 85px 107px;
          height: 107px;
          width: 85px;
          position: absolute;
          top: -20px;
          right: 10px;
          display: none;
        }
      
        .promotional_label {
          background-image: url(~@/assets/todesk/pricing/dt/promotional_label.png);
          background-size: 91px 30px;
          background-position: center;
          background-repeat: no-repeat;
          height: 30px;
          width: 316px;
          position: absolute;
          z-index: 2;
          margin-top: -19px;
        }
      
        .large_scale_back {
          background-image: url(~@/assets/todesk/pricing/dt/large_scale_back.png);
          background-size: 85px 107px;
          height: 107px;
          width: 85px;
          position: absolute;
          top: -20px;
          right: 10px;
          display: none;
        }

        .main_current:hover .main_back {
          display: block;
        }

        .s_back{
          background-size: 85px 107px;
          height: 107px;
          width: 85px;
          position: absolute;
          top: -20px;
          right: 10px;
          display: none;
          &.aigc1_back{
            background-image: url(~@/assets/todesk/pricing/dt/aigc1_back.png);
          }
          &.aigc2_back{
            background-image: url(~@/assets/todesk/pricing/dt/aigc2_back.png);
          }
        }
      
        .large-scale:hover .large_scale_back {
          display: block;
        }
        .aigc1:hover .s_back {
          display: block;
        }
        .aigc2:hover .s_back {
          display: block;
        }
      
        .main_current:hover .t_content {
          background: linear-gradient(179.96deg, #D0F4FF 0.03%, #F6FDFF 95.72%);
        }
      
        .large-scale:hover .t_content {
          background: linear-gradient(180deg, #FFEDAB 0%, #FEFDF5 100%);
        }

        .aigc1:hover .t_content {
          background: linear-gradient(180deg, #FFD8AB 0%, #FEFAF5 100%);
        }
        
        .aigc2:hover .t_content {
          background: linear-gradient(180deg, #FED8E6 0%, #FFFFFF 100%);
        }
      }
      .price1{
        color: #F86B00;
        &.coming_aigc1{
            color: #C65600;
        }
        &.coming_aigc2{
            color: #C60047;
        }
        .price_text1{
            font-weight: 700;
            font-size: 20px;
        }
        .price_text2{
            font-size: 40px;
            font-weight: 700;
        }
        .price_text3{
            font-size: 20px;
            font-weight: 700;
        }
        .price_text4{
            color: #00000099;
            font-size: 16px;
            font-weight: 400;
        }
      }
    }
  }
}
</style>